export default "__VITE_ASSET__95fcd431__"